"use strict";

import { incentiveConstants } from "../_constants";

let uniqueChildren = {};
let allChildren = [];

function addUniqueChildren(parent) {
     parent.children.forEach((child) => {
          if (!uniqueChildren[child.key]) {
               uniqueChildren[child.key] = child;
               allChildren.push(child);
          }
     });
}

function updateParentCheckedStatus(data1, data2) {
     for (let section in data1) {
          if (section != "all") {
               data1[section].forEach((parent) => {
                    let allChildrenChecked = true;

                    parent.children.forEach((child) => {
                         if (!data2[child.key] || !data2[child.key].checked) {
                              allChildrenChecked = false;
                         }
                    });

                    if (allChildrenChecked) {
                         data2[parent.key] = {
                              checked: true,
                              partialChecked: false,
                         };
                    }
               });
          }
     }

     return data2;
}

const createDataStructure = (jsonResponse) => {
     const data = {
          all: [],
     };

     // Initialize empty arrays for each participant group
     jsonResponse.participantGroups.forEach((group) => {
          data[group.code] = [];
     });

     const groupMaps = {};

     jsonResponse.participantGroups.forEach((group) => {
          groupMaps[group.code] = {};
     });

     jsonResponse.participants.forEach((participant) => {
          const { userId, firstName, middleName, lastName, email } =
               participant;
          const userKey = userId.toString();
          const name = firstName + " " + middleName + " " + lastName;

          participant.incentiveCampaignParticipantGroups.forEach((group) => {
               const { groupName, groupValue } = group;

               if (!groupMaps[groupName][groupValue]) {
                    const key = `parent_${groupName}_${
                         Object.keys(groupMaps[groupName]).length
                    }`;
                    groupMaps[groupName][groupValue] = {
                         key,
                         data: { name: groupValue },
                         children: [],
                    };
               }

               groupMaps[groupName][groupValue].children.push({
                    key: userKey,
                    data: { name, email },
               });
          });
     });

     jsonResponse.participantGroups.forEach((group) => {
          data[group.code] = Object.values(groupMaps[group.code]);
     });

     Object.keys(data).forEach((key) => {
          if (key !== "all") {
               data[key].forEach((parent) => {
                    addUniqueChildren(parent);
               });
          }
     });

     // Assign unique children to the "all" array
     data.all = allChildren;

     return data;
};

export const INCENTIVE_TABLE_STATE = {
     list: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },
     types: [],
     camapaignTypes: [],

     campaignSales: [],
     campaignTemplateType: [],
     campaignProducts: [],
     participantList: [],

     contentHeaderRevisionPublished:{},

     contentHeaderRevisionList: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },

     publishedRevisionContent:{},

     loadHeaderContent: false,

     contentHeaderDetails: {},

     contentAboutDetails: {},

     contentQuickDetails: {},

     contentTermDetails: {},

     contentFaqDetails: {},

     participantDataTemplates: [],
     salseDataTemplates: [],
     aboutCampaignStepOne: {},

     participantGroups: [],
     participants: {},
     campaignParticipants: {},
     campaignAdmins: [],

     contentAboutRevisionList: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },

     contentAboutRevisionPublished:{},

     contentQuickRevisionList: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },

     contentQuickRevisionPublished:{},

     contentTermRevisionList: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },

     contentTermRevisionPublished:{},

     contentFaqRevisionList: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },

     contentFaqRevisionPublished:{},
};

export function incentive(state = INCENTIVE_TABLE_STATE, action) {
     switch (action.type) {
          case incentiveConstants.LIST_CAMPAIGN_PARTICIPANTS_COMPLETE:
               const participantData = createDataStructure(action.payload);
               let result = {};

               action.payload.participants.forEach((participant) => {
                    result[participant.userId] = {
                         checked: participant.assigned,
                         partialChecked: false,
                    };
               });

               result = updateParentCheckedStatus(participantData, result);

               return {
                    ...state,

                    participantGroups: [...action.payload.participantGroups],
                    participants: { ...participantData },
                    campaignParticipants: { ...result },
               };

          case incentiveConstants.INCENTIVE_HEADER_CONTENT_GET_COMPLETE:
               return {
                    ...state,
                    contentHeaderDetails: { ...action?.payload },
                    loadHeaderContent: true,
               };

          case incentiveConstants.INCENTIVE_HEADER_CONTENT_GET_REQUEST:
               return {
                    ...state,
                    loadHeaderContent: false,
               };
          case incentiveConstants.INCENTIVE_HEADER_CONTENT_LIST_COMPLETE:
               return {
                    ...state,
                    contentHeaderRevisionList: {
                         data: [...action?.payload?.recordsList],
                         totalPageCount: action?.payload?.totalPageCount,
                         totalRecords: action?.payload?.totalRecords,
                    },
               };

          case incentiveConstants.INCENTIVE_GET_HEADER_PUBLISHED_REVISION_CONTENT_COMPLETE:

               return {
                    ...state,
                    contentHeaderRevisionPublished:action?.payload
               };

          case incentiveConstants.INCENTIVE_HEADER_CONTENT_ADD_COMPLETE:
               return {
                    ...state,
                    loadHeaderContent: false,
               };

          /**
           * Customer login
           */

          case incentiveConstants.INCENTIVE_TABLE_LIST_REQUEST:
               return {
                    ...state,
                    list: {
                         data: [],
                         totalPageCount: 0,
                         totalRecords: 0,
                    },
               };

          case incentiveConstants.INCENTIVE_TABLE_LIST_COMPLETE:
               return {
                    ...state,
                    list: {
                         data: [...action?.payload?.recordsList],
                         totalPageCount: action?.payload?.totalPageCount,
                         totalRecords: action?.payload?.totalRecords,
                    },
               };

          case incentiveConstants.INCENTIVE_TYPES_COMPLETE:
               return {
                    ...state,
                    types: [...action?.payload],
               };

          case incentiveConstants.INCENTIVE_TABLE_SEARCH_LIST_COMPLETE:
               return {
                    ...state,
                    list: {
                         data: [...action?.payload?.recordsList],
                         totalPageCount: action?.payload?.totalPageCount,
                         totalRecords: action?.payload?.totalRecords,
                    },
               };

          case incentiveConstants.GET_CAMPAIGN_TYPES_COMPLETE:
               return {
                    ...state,
                    camapaignTypes: [...action.payload],
               };

          case incentiveConstants.GET_CAMPAIGN_PARTICIPANTS_COMPLETE:
               return {
                    ...state,
                    campaignParticipants: [...action.payload.recordsList],
               };
          case incentiveConstants.GET_CAMPAIGN_SALES_COMPLETE:
               return {
                    ...state,
                    campaignSales: [...action.payload.recordsList],
               };

          case incentiveConstants.GET_CAMPAIGN_TEMPLATE_TYPES_COMPLETE:
               return {
                    ...state,
                    campaignTemplateType: [...action.payload],
               };

          case incentiveConstants.GET_CAMPAIGN_PRODUCTS_COMPLETE:
               return {
                    ...state,
                    campaignProducts: [...action.payload.recordsList],
               };

          case incentiveConstants.GET_PARTICIPANT_LIST_COMPLETE:
               return {
                    ...state,
                    participantList: [...action.payload.recordsList],
               };

          case incentiveConstants.GET_PARTICIPANT_DATA_TEMPLATE_COMPLETE:
               return {
                    ...state,
                    participantDataTemplates: [...action.payload],
               };

          case incentiveConstants.GET_SALSE_DATA_TEMPLATE_COMPLETE:
               return {
                    ...state,
                    salseDataTemplates: [...action.payload],
               };

          case incentiveConstants.GET_ABOUT_CAMPAIGN_STEP_ONE_COMPLETE:
               return {
                    ...state,
                    aboutCampaignStepOne: { ...action.payload },
               };

          case incentiveConstants.LIST_CAMPAIGN_ADMINS_COMPLETE:
               return {
                    ...state,
                    campaignAdmins: [
                         ...action.payload.map((user) => {
                              user.id = user.userId;
                              user.permissions = {
                                   updateContent: user.updateCampaignPermission,
                                   requestBudget:
                                        user.requestRewardBudgetPermission,
                                   distributeRewards:
                                        user.distributeRewardPermission,
                              };
                              return user;
                         }),
                    ],
               };

          case incentiveConstants.INCENTIVE_ABOUT_REVISION_CONTENT_LIST_COMPLETE:
               return {
                    ...state,
                    contentAboutRevisionList: {
                         data: [...action?.payload?.recordsList],
                         totalPageCount: action?.payload?.totalPageCount,
                         totalRecords: action?.payload?.totalRecords,
                    },
               };

          case incentiveConstants.INCENTIVE_GET_ABOUT_PUBLISHED_REVISION_CONTENT_COMPLETE:

               return {
                    ...state,
                    contentAboutRevisionPublished:action?.payload
               };

          case incentiveConstants.INCENTIVE_ABOUT_CONTENT_GET_COMPLETE:
               return {
                    ...state,
                    contentAboutDetails: { ...action?.payload },
                    loadHeaderContent: true,
               };

          case incentiveConstants.INCENTIVE_QUICK_REVISION_CONTENT_LIST_COMPLETE:
               return {
                    ...state,
                    contentQuickRevisionList: {
                         data: [...action?.payload?.recordsList],
                         totalPageCount: action?.payload?.totalPageCount,
                         totalRecords: action?.payload?.totalRecords,
                    },
               };
               
          case incentiveConstants.INCENTIVE_GET_QUICK_PUBLISHED_REVISION_CONTENT_COMPLETE:

          return {
               ...state,
               contentQuickRevisionPublished:action?.payload
          };



          case incentiveConstants.INCENTIVE_QUICK_CONTENT_GET_COMPLETE:
               
          return {
               ...state,
               contentQuickDetails: { ...action?.payload },
               loadHeaderContent: true,
          };

          
          case incentiveConstants.INCENTIVE_TERM_CONTENT_LIST_COMPLETE:
               return {
                    ...state,
                    contentTermRevisionList: {
                         data: [...action?.payload?.recordsList],
                         totalPageCount: action?.payload?.totalPageCount,
                         totalRecords: action?.payload?.totalRecords,
                    },
               };

          
          case incentiveConstants.INCENTIVE_GET_TERM_PUBLISHED_REVISION_CONTENT_COMPLETE:

               return {
                    ...state,
                    contentTermRevisionPublished:action?.payload
               };


          case incentiveConstants.INCENTIVE_TERM_CONTENT_GET_COMPLETE:
               
               return {
                    ...state,
                    contentTermDetails: { ...action?.payload },
                    loadHeaderContent: true,
               };
     

          case incentiveConstants.INCENTIVE_FAQ_CONTENT_LIST_COMPLETE:
               return {
                    ...state,
                    contentFaqRevisionList: {
                         data: [...action?.payload?.recordsList],
                         totalPageCount: action?.payload?.totalPageCount,
                         totalRecords: action?.payload?.totalRecords,
                    },
               };

          case incentiveConstants.INCENTIVE_GET_FAQ_PUBLISHED_REVISION_CONTENT_COMPLETE:

               return {
                    ...state,
                    contentFaqRevisionPublished:action?.payload
               };

          case incentiveConstants.INCENTIVE_FAQ_CONTENT_GET_COMPLETE:
               
               return {
                    ...state,
                    contentFaqDetails: { ...action?.payload },
                    loadHeaderContent: true,
               };
     
     }

     return state;
}
